module.exports = __webpack_public_path__ + "img/Hiraya-Icons-Save-Money-Save-Water.7b57fe3f.png";